
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 20 13","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M10 .167c-4.167 0-7.725 2.591-9.167 6.25 1.442 3.658 5 6.25 9.167 6.25s7.725-2.592 9.167-6.25c-1.442-3.659-5-6.25-9.167-6.25zm0 10.416a4.168 4.168 0 01-4.167-4.166C5.833 4.117 7.7 2.25 10 2.25s4.167 1.867 4.167 4.167S12.3 10.583 10 10.583zm0-6.666a2.497 2.497 0 00-2.5 2.5c0 1.383 1.117 2.5 2.5 2.5s2.5-1.117 2.5-2.5c0-1.384-1.117-2.5-2.5-2.5z","fill":"currentColor"}})])
          )
        }
      }
    